import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import Table from '../../../../src/components/Table/Table';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const AdminWorkoutsReviewTable = ({ workouts, onReviewWorkout }) => {
  const columns = [
    { title: 'Workout Name', field: 'name' },
    { title: 'Description', field: 'description' },
    {
      title: 'Equipment Needed',
      field: 'equipmentNeeded',
      render: (rowData) =>
        rowData.equipmentNeeded ? <CheckIcon color="primary" /> : <CloseIcon color="error" />,
    },
    { title: 'Category', field: 'categoryName' },
    {
      title: 'Reviewed',
      field: 'isReviewed',
      render: (rowData) =>
        rowData.isReviewed ? <CheckIcon color="primary" /> : <CloseIcon color="error" />,
    },
    {
      title: 'Approved',
      field: 'isApproved',
      render: (rowData) =>
        rowData.isApproved ? <CheckIcon color="primary" /> : <CloseIcon color="error" />,
    },
    {
      title: 'Actions',
      field: 'actions',
      render: (rowData) => (
        <Box display="flex" gap={1}>
          <Button
            variant="contained"
            color="success"
            disabled={rowData.isReviewed}
            onClick={() => onReviewWorkout({ ...rowData, isApproved: true })}
          >
            Approve
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={rowData.isReviewed}
            onClick={() => onReviewWorkout({ ...rowData, isApproved: false })}
          >
            Deny
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Table
      title="Admin Workouts Review"
      columns={columns}
      data={workouts}
      options={{
        paging: true,
        search: true,
        sorting: true,
      }}
    />
  );
};

AdminWorkoutsReviewTable.propTypes = {
  workouts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      equipmentNeeded: PropTypes.bool.isRequired,
      categoryName: PropTypes.string.isRequired,
      isReviewed: PropTypes.bool.isRequired,
      isApproved: PropTypes.bool.isRequired,
    })
  ).isRequired,
  onReviewWorkout: PropTypes.func.isRequired,
};

export default AdminWorkoutsReviewTable;
